import React, { Component } from 'react';
import parse from 'html-react-parser';
import { Analytics } from '../../../utils/common/analytics';
import PropTypes from 'prop-types';

class ValidationError extends Component {
	logError() {
		if (this.props.errorCode >= 2 && this.props.errorCode <= 10) {
			const err = this.getErrorLogMessage();
			this.analytics.addEvent(Analytics.eventType.ERROR, {
				errorDesc: err,
			});
			const errorMessage = this.analytics.getPageItem('errorMessage') || [];
			errorMessage.push({
				event: 'eventWebAppMsg',
				data: {
					eventType: 'page error',
					errorMessage: err,
				},
			});
			this.analytics.addPageInfo({
				errorMessage,
			});
		}
	}

	getErrorLogMessage() {
		let errorMessage;
		switch (this.props.errorCode) {
			case 2:
				errorMessage = 'Quantity Error';
				break;
			case 3:
				errorMessage = 'Foundational User Type Required';
				break;
			case 4:
				errorMessage = 'Not Enough Core Licenses';
				break;
			case 5:
				errorMessage = 'Assign Core License';
				break;
			case 6:
				errorMessage = 'Maximum Core Licenses Assigned';
				break;
			case 8:
				errorMessage = 'Consumer Use Only';
				break;
			case 9:
				errorMessage = 'Not Sold Online';
				break;
			case 10:
				errorMessage = 'ArcGIS Enterprise Deployment Required';
				break;
			default:
				errorMessage = null;
		}
		return errorMessage;
	}

	componentDidMount() {
		this.analytics = Analytics.getInstance();
		this.logError();
	}

	componentDidUpdate(prevProps) {
		if (this.props.errorCode !== prevProps.errorCode) {
			this.logError();
		}
	}

	render() {
		return (
			<div className="cart-alert topborder">
				<div className="cart-alert-icon"></div>
				<div className="cart-alert-text">
					{this.props.title && (
						<div>
							<span className="avenir-bold"> {this.props.title} </span> <br />
						</div>
					)}
					<div className="richtext-container">{this.props.message && parse(this.props.message)}</div>
				</div>
			</div>
		);
	}
}

ValidationError.propTypes = {
  errorCode: PropTypes.number,
  title: PropTypes.string,
  message: PropTypes.string,
};

export default ValidationError;
